import { Link, useLocation } from "react-router-dom";

// Persistent unobtrusive mobile reserve button
export const MobileReserveBar = () => {
  const location = useLocation();
  if (location.pathname === "/reservations") return null;
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 p-3 bg-gradient-to-t from-[#0a0908] via-[#0a0908]/90 to-transparent pointer-events-none">
      <Link
        to="/reservations"
        data-testid="mobile-reserve-bar"
        className="pointer-events-auto block w-full bg-[#C1272D] text-[#0a0908] text-center py-4 text-xs font-semibold tracking-[0.25em] uppercase"
      >
        Reserve
      </Link>
    </div>
  );
};
